// CSV export of loaded rows — client-side only, honest about what's loaded.

export interface CsvColumn<T> {
  header: string;
  value: (row: T) => unknown;
}

function cell(v: unknown): string {
  if (v == null) return '';
  const s = typeof v === 'object' ? JSON.stringify(v) : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv<T>(columns: CsvColumn<T>[], rows: T[]): string {
  const head = columns.map((c) => cell(c.header)).join(',');
  const body = rows.map((r) => columns.map((c) => cell(c.value(r))).join(','));
  return [head, ...body].join('\r\n');
}

/** Save text as a file. The BOM helps spreadsheets read CSV as UTF-8; other formats (e.g. .ics) pass `bom: false`. */
export function downloadText(filename: string, text: string, mime = 'text/csv;charset=utf-8', bom = true) {
  if (typeof document === 'undefined') return;
  const blob = new Blob([(bom ? '﻿' : '') + text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
